import { createContext, useContext, useReducer } from "react";

export const initialSettings = {
	discussion: false,
	article: false,
	notes: false,
	comments: false,
	remark: false,
	reportError: false,
	statistics: false,
	questionLevel: false,
	aiDiscussion: false,
	ownDiscussion: false,
};

const initialState = {
	settings: initialSettings,
};

function settingsReducer(state, action) {
	switch (action.type) {
		case "toggle_settings":
			return {
				...state,
				settings: {
					...initialSettings,
					statistics: state.settings.statistics,
					questionLevel: state.settings.questionLevel,
					[action.payload]: !state.settings[action.payload],
				},
			};
		case "reset_settings":
			return {
				...state,
				settings: {
					...initialSettings,
					questionLevel: state.settings.questionLevel,
					statistics: state.settings.statistics,
				},
			};
		case "reset_all_settings":
			return {
				...state,
				settings: {
					...initialSettings,
				},
			};
		default:
			return state;
	}
}

const QuestionSettingsContext = createContext();

export function QuestionSettingsProvider({ children }) {
	const [state, dispatch] = useReducer(settingsReducer, initialState);

	return (
		<QuestionSettingsContext.Provider value={{ state, dispatch }}>
			{children}
		</QuestionSettingsContext.Provider>
	);
}

export function useQuestionSettings() {
	const context = useContext(QuestionSettingsContext);
	if (context === undefined) {
		return {};
	}
	return context;
}
